import { FormValidatorFn, FormValidationErrors } from '../validators.models';

export const phoneValidatorFn: FormValidatorFn = (value: string) => {
    const phoneRegex = /^06[0-9]{8}$/;

    return phoneRegex.test(value) ? null : FormValidationErrors.Phone;
}
